<template>
  <div>
    <slot />
  </div>
</template>
<script>

export default {
  components: {},
  mounted() {
    if (this.$session.get('language')) {
      this.$initTranslation().then(() => {
        this.$translate.setLang(this.$session.get('language'))
      })
    }
  },
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/layouts/Unauth.vue